import axiosInstance from "api/axiosInstance";

const logoutUser = async (accessToken) => {
    return await axiosInstance.get(
        "/auth/logout",
        {},
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
};
export default logoutUser;